import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { userRequest } from '../../../utils/requestMethods';
import { Header, CustomPagination, StatusBadge, SkeletonTable, BackButton } from '../../../components';
import { MdSearch } from 'react-icons/md';

const customStyles = {
  headRow: {
    style: {
      backgroundColor: 'rgb(248, 250, 252)',
      fontWeight: "bold",
    },
  },
};

const StudentResults = ({ history }) => {
  const location = useLocation();
  const classId = location.pathname.split('/')[4];
  //console.log(classId)
  const [students, setStudents] = useState([]);
  //const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState('');

  const fetchStudents = async (classId) => {
    if (classId) {
      try {
        setLoading(true);
        const { data } = await userRequest.get(`children/class/${classId}?limit=200`);
        //console.log(data.children);
        setStudents(data.children);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchStudents(classId);
  }, [classId]);
  
  const columns = [
    {
      name: "Surname",
      selector: row => row.lastname
    },
    {
      name: "First Name",
      selector: row => row.firstname
    },
    {
      name: "Gender",
      selector: row => row.gender
    },
    {
      name: "Class",
      selector: row => row.class_info.class_name
    },
    {
      name: "Status",
      selector: row => (
        <div>
          {row.academic_status ? (
            <StatusBadge status="active" />
          ) : (
            <StatusBadge status="inactive" />
          )}
        </div>
      )
    },
    {
      name: 'Action',
      cell: (row) => (
        <Link to={{ pathname: `/t/results/student/${row._id}`, state: { student: row } }} className="font-medium text-[#00509D] hover:underline">View</Link>
      ),
      ignoreRowClick: true,
      button: true,
    },
  ];

  const filteredData = students
    ?.filter((item) =>
      (item.firstname?.toLowerCase().includes(filterText.toLowerCase()) || '') ||
      (item.lastname?.toLowerCase().includes(filterText.toLowerCase()) || '')
    )
    .sort((a, b) => {
      const surnameA = a.lastname || '';
      const surnameB = b.lastname || '';
      return surnameA.localeCompare(surnameB);
    });

  return (
    <>
    <div className="px-3 md:px-10 pt-10 md:pt-5 mt-10">
    <BackButton history={history} />
      <div className="flex flex-wrap justify-between items-center mb-4">
        <Header category="Results" title="Class Result" />
      </div>
    </div>

    <div className="m-2 md:mx-10 p-4 md:p-10 bg-white rounded-3xl dark:bg-secondary-dark-bg min-h-screen">
      <div className="flex flex-wrap justify-between items-center mb-4">
        <h1 className="text-lg font-semibold w-full md:w-auto mb-2 md:mb-0" style={{ maxWidth: "20em" }}>
          Class Results
        </h1>
        <div className="flex flex-wrap justify-center md:justify-end w-full md:w-auto gap-2">
          {/* Search Input */}
          <form className="w-full md:w-auto">
            <div className="relative">
              <div className="absolute inset-y-0 start-0 flex items-center pl-4 pointer-events-none">
                <MdSearch />
              </div>
              <input type="text" value={filterText} onChange={(e) => setFilterText(e.target.value)} className="w-full sm:w-auto bg-gray-50 border border-gray-300 text-gray-900 text-sm sm:text-md rounded-full focus:ring-blue-500 focus:border-blue-500 block pl-8 p-2.5" placeholder="Search"/>
            </div>
          </form>
        </div>
      </div>
      <div className="border rounded-3xl">
        <DataTable
          data={filteredData}
          columns={columns}
          getRowId={(row) => row._id}
          pagination
          paginationComponent={CustomPagination}
          customStyles={customStyles}
          progressPending={loading}
          progressComponent={<SkeletonTable rows={5} columns={6} />}
          highlightOnHover
          striped
          onRowClicked={(row) => {
            history.push({
              pathname: `/t/results/student/${row._id}`, state: { student: row }
            });
          }}
          pointerOnHover
        />
      </div>
    </div>
    </>
  );
};
export default StudentResults;
